export default __webpack_public_path__ + "static/media/dum_2.40ccf084.png";